import pino, { type Logger } from 'pino';

export { type Logger } from 'pino';

export const logger = pino({
  name: 'data-collection',
  level: 'debug',

  browser: {
    asObject: true,
    serialize: true,
  },
});

export const createAppLogger = (appName: string): Logger =>
  logger.child({ app: appName });

export const createModuleLogger = (moduleName: string, parentLogger: Logger) =>
  parentLogger.child({ module: moduleName });
